import { markerCenterIconUrl, markerIconUrl, selectedMarkerIconUrl } from '../constants/icon-urls'

export class MarkerIconFactory {
  static defaultMarkerIcon(): google.maps.Icon {
    return { url: markerIconUrl, scaledSize: new google.maps.Size(35, 48) }
  }
  static userLocationIcon(): google.maps.Icon {
    return { url: markerCenterIconUrl, scaledSize: new google.maps.Size(51, 64) }
  }
  static selectedMarkerIcon(): google.maps.Icon {
    return { url: selectedMarkerIconUrl, scaledSize: new google.maps.Size(35, 48) }
  }
}
